// extracted by mini-css-extract-plugin
export default {"MessageSent":"MessageSent_MessageSent__r11IK","Success":"MessageSent_Success__dA0r3","Failed":"MessageSent_Failed__jI-Vr"};